import { render, staticRenderFns } from "./addOrg.vue?vue&type=template&id=a12fbce2&"
import script from "./addOrg.vue?vue&type=script&lang=ts&"
export * from "./addOrg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports